// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherOutlinedSvg from "@ant-design/icons-svg/es/asn/SwitcherOutlined";
import AntdIcon from '../components/AntdIcon';

var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherOutlinedSvg
  }));
};

SwitcherOutlined.displayName = 'SwitcherOutlined';
export default React.forwardRef(SwitcherOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SwitcherOutlined.js
// module id = 1897
// module chunks = 0